import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducer';
import rootSaga from './saga';
import { composeWithDevTools } from 'redux-devtools-extension';

const sagaMiddleware = createSagaMiddleware();
const store =
    // eslint-disable-next-line no-undef
    process.env.NODE_ENV === 'production'
        ? createStore(rootReducer, applyMiddleware(sagaMiddleware))
        : createStore(
              rootReducer,
              composeWithDevTools(
                  applyMiddleware(sagaMiddleware, createLogger())
              )
          );

sagaMiddleware.run(rootSaga);

const persistor = persistStore(store);

export default { store, persistor };
